// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/_css-loader@3.6.0@css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".foot[data-v-7a859b44]{font-size:14px;color:#b2b7bf;text-align:center;width:100%;height:50px;line-height:50px}a[data-v-7a859b44]:active,a[data-v-7a859b44]:hover,a[data-v-7a859b44]:link,a[data-v-7a859b44]:visited{color:#b2b7bf;font-size:14px;text-decoration:none}", ""]);
// Exports
module.exports = exports;
